import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cancel: {
    id: 'ratings.reply-to-review.cancel',
    defaultMessage: 'Cancel',
  },
  fieldRequired: {
    id: 'ratings.reply-to-review.validation-error.field-required',
    defaultMessage: 'This field is required.',
  },
  replyInputPlaceholder: {
    id: 'ratings.reply-to-review.reply-input-placeholder',
    defaultMessage:
      'E.g.: Thanks for the feedback! Our staff strive to make every experience the best experience. Hope to see you soon!',
  },
  submit: {
    id: 'ratings.reply-to-review.submit',
    defaultMessage: 'Post reply',
  },
  visibilityDisclaimerText: {
    id: 'ratings.reply-to-review.visibility-disclaimer.text',
    defaultMessage:
      'Your response will be shown publicly to all ClassPass members next to this review. For more information about our content policy, <a>read our guidelines.</a>',
  },
});
